import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'
const spacing1x = 'var(--spacing-1x, 1rem)'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
import { useFlag } from '@calendly/feature-check-react'

import { useI18n } from 'locales'
import _StyledLink from "legal_copy-StyledLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/scheduling_form_feature/legal_copy.js?styleId=StyledLink";
import _Container from "legal_copy-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/scheduling_form_feature/legal_copy.js?styleId=Container";


const StyledLink = /*#__PURE__*/styled(Link, null, {
  displayName: "StyledLink",
  styles: _StyledLink
})
const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const LegalCopy = () => {
  const { i18n } = useI18n()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  return (
    <Container bookingAppRedesign={bookingAppRedesign}>
      {`${i18n.t('booking.terms_and_conditions.base_language')} `}
      <StyledLink
        underline={bookingAppRedesign}
        href="https://calendly.com/legal/participant-terms-conditions"
        target="_blank"
        rel="related"
        variant={bookingAppRedesign ? 'subtle' : 'primary'}
      >
        {`${i18n.t('booking.terms_and_conditions.calendly_invitee_terms')} `}
      </StyledLink>
      {` ${i18n.t('booking.terms_and_conditions.and')} `}
      <StyledLink
        underline={bookingAppRedesign}
        href="https://calendly.com/privacy"
        target="_blank"
        rel="related"
        variant={bookingAppRedesign ? 'subtle' : 'primary'}
      >
        {` ${i18n.t('booking.terms_and_conditions.privace_notice')}`}
        .
      </StyledLink>
    </Container>
  )
}

export default LegalCopy
